import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { api } from "../../api/api.js";
import { selectAvailableFilterValuesParameters } from "./selectAvailableFilterValuesParameters.js";
import { selectSlice } from "./selectSlice.js";
const selectAvailableFilterValues = createAppSelector(
  [selectSlice, selectAvailableFilterValuesParameters],
  (filterValues, parameters) => {
    return api.endpoints.getAvailableFilterValues.select(parameters)({
      filterValues
    });
  }
);
export {
  selectAvailableFilterValues
};
